import axios from "axios";
import {DYNAMIC_CAT_UPD, DYNAMIC_FORM_GET, DYNAMIC_FORM_GET_ALL, DYNAMIC_FORM_UPD_CRT} from "./utils/ApiUrls";
import {authLogout} from "./AuthServices";

export function getDynamicFormConfig(formId) {
    const url = DYNAMIC_FORM_GET.replace("{id}", formId);

    return axios
        .get(url)
        .then((response) => {
            if (response.status === 226) {
                authLogout();
            } else {
                return response.data;
            }
        })
        .catch((error) => {
            window.alert(error.message);
            throw error;
        });
}

export function getAllDynamicForm() {
    return axios
        .get(DYNAMIC_FORM_GET_ALL)
        .then((response) => {
            if (response.status === 226) {
                authLogout();
            } else {
                return response.data;
            }
        })
        .catch((error) => {
            window.alert(error.message);
            throw error;
        });
}

export function updateOrCreateDynamicForm(dynamicForm) {
    console.log("POST")
    return axios
        .post(DYNAMIC_FORM_UPD_CRT, dynamicForm)
        .then((response) => {
            if (response.status === 226) {
                authLogout();
            } else {
                return response.data;
            }
        })
        .catch((error) => {
            window.alert(error.message);
            throw error;
        });
}

export function updateDynamicCategories(data) {
    console.log("POST")
    return axios
        .post(DYNAMIC_CAT_UPD, data)
        .then((response) => {
            if (response.status === 226) {
                authLogout();
            } else {
                return response.data;
            }
        })
        .catch((error) => {
            window.alert(error.message);
            throw error;
        });
}
